var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _line, _line2, _line3, _line4, _line5, _line6, _line7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _text, _text2, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _text3, _text4, _rect16, _rect17, _line15, _line16, _line17, _line18, _line19, _polyline, _polygon, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _text5, _text6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyChartZones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 420 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "z-bg",
    cx: "50%",
    cy: "40%",
    r: "60%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F6F8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDF0EF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "z-grid",
    x: 0,
    y: 0,
    width: 14,
    height: 14,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 0.6,
    fill: "#C7D1CC",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z-zone0",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f87171",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f87171",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z-zone1",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fb923c",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fb923c",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z-zone2",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#facc15",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#facc15",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z-zone3",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4ade80",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4ade80",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z-zone4",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#60a5fa",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#60a5fa",
    stopOpacity: 0.04
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 200,
    rx: 14,
    fill: "url(#z-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 126,
    height: 184,
    rx: 8,
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 96,
    height: 156,
    fill: "url(#z-grid)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 19,
    height: 156,
    fill: "url(#z-zone0)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 20,
    width: 19,
    height: 156,
    fill: "url(#z-zone1)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 20,
    width: 19,
    height: 156,
    fill: "url(#z-zone2)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 20,
    width: 19,
    height: 156,
    fill: "url(#z-zone3)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 20,
    width: 20,
    height: 156,
    fill: "url(#z-zone4)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 176,
    x2: 126,
    y2: 176,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 20,
    x2: 30,
    y2: 176,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 170,
    x2: 126,
    y2: 40,
    stroke: "#f87171",
    strokeWidth: 1,
    strokeOpacity: 0.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 176,
    x2: 126,
    y2: 60,
    stroke: "#fb923c",
    strokeWidth: 1,
    strokeOpacity: 0.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 176,
    x2: 126,
    y2: 88,
    stroke: "#facc15",
    strokeWidth: 1,
    strokeOpacity: 0.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 176,
    x2: 126,
    y2: 118,
    stroke: "#4ade80",
    strokeWidth: 1,
    strokeOpacity: 0.7
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 176,
    x2: 126,
    y2: 148,
    stroke: "#60a5fa",
    strokeWidth: 1,
    strokeOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 148,
    r: 2.8,
    fill: "#60a5fa",
    fillOpacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 132,
    r: 2.8,
    fill: "#4ade80",
    fillOpacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 110,
    r: 2.8,
    fill: "#facc15",
    fillOpacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 98,
    r: 2.8,
    fill: "#facc15",
    fillOpacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 80,
    r: 2.8,
    fill: "#fb923c",
    fillOpacity: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 68,
    r: 2.8,
    fill: "#f87171",
    fillOpacity: 0.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 55,
    r: 2.8,
    fill: "#f87171",
    fillOpacity: 0.8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 155,
    r: 2.8,
    fill: "#60a5fa",
    fillOpacity: 0.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 122,
    r: 2.8,
    fill: "#4ade80",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 72,
    r: 2.8,
    fill: "#fb923c",
    fillOpacity: 0.8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 193,
    textAnchor: "middle",
    fontSize: 7.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF"
  }, "PHIZ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 19,
    y: 98,
    textAnchor: "middle",
    fontSize: 7.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90,19,98)"
  }, "RQI")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 8,
    width: 126,
    height: 184,
    rx: 8,
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 20,
    width: 96,
    height: 156,
    fill: "url(#z-grid)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 20,
    width: 19,
    height: 156,
    fill: "url(#z-zone0)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 20,
    width: 19,
    height: 156,
    fill: "url(#z-zone1)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 20,
    width: 19,
    height: 156,
    fill: "url(#z-zone2)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 20,
    width: 19,
    height: 156,
    fill: "url(#z-zone3)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 20,
    width: 20,
    height: 156,
    fill: "url(#z-zone4)"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 176,
    x2: 265,
    y2: 176,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 20,
    x2: 169,
    y2: 176,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 170,
    x2: 265,
    y2: 30,
    stroke: "#f87171",
    strokeWidth: 1,
    strokeOpacity: 0.7
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 176,
    x2: 265,
    y2: 55,
    stroke: "#fb923c",
    strokeWidth: 1,
    strokeOpacity: 0.7
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 176,
    x2: 265,
    y2: 88,
    stroke: "#facc15",
    strokeWidth: 1,
    strokeOpacity: 0.7
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 176,
    x2: 265,
    y2: 120,
    stroke: "#4ade80",
    strokeWidth: 1,
    strokeOpacity: 0.7
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 176,
    x2: 265,
    y2: 150,
    stroke: "#60a5fa",
    strokeWidth: 1,
    strokeOpacity: 0.7
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 152,
    r: 2.8,
    fill: "#60a5fa",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 136,
    r: 2.8,
    fill: "#4ade80",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 112,
    r: 2.8,
    fill: "#facc15",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 95,
    r: 2.8,
    fill: "#facc15",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 74,
    r: 2.8,
    fill: "#fb923c",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 232,
    cy: 55,
    r: 2.8,
    fill: "#f87171",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 36,
    r: 2.8,
    fill: "#f87171",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 158,
    r: 2.8,
    fill: "#60a5fa",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 118,
    r: 2.8,
    fill: "#4ade80",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 68,
    r: 2.8,
    fill: "#fb923c",
    fillOpacity: 0.8
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 217,
    y: 193,
    textAnchor: "middle",
    fontSize: 7.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF"
  }, "Porosity (%)")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 98,
    textAnchor: "middle",
    fontSize: 7.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90,158,98)"
  }, "K (mD)")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 8,
    width: 126,
    height: 184,
    rx: 8,
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 20,
    width: 96,
    height: 156,
    fill: "url(#z-grid)"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 308,
    y1: 60,
    x2: 404,
    y2: 60,
    stroke: "#E0E6E3",
    strokeWidth: 0.6
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 308,
    y1: 98,
    x2: 404,
    y2: 98,
    stroke: "#E0E6E3",
    strokeWidth: 0.6
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 308,
    y1: 137,
    x2: 404,
    y2: 137,
    stroke: "#E0E6E3",
    strokeWidth: 0.6
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 308,
    y1: 176,
    x2: 404,
    y2: 176,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 308,
    y1: 20,
    x2: 308,
    y2: 176,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "308,176 318,174 322,168 326,158 330,142 336,122 342,105 350,88 356,74 362,62 370,50 378,40 388,32 396,26 404,23",
    stroke: "#32d1c8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "308,176 318,174 322,168 326,158 330,142 336,122 342,105 350,88 356,74 362,62 370,50 378,40 388,32 396,26 404,23 404,176",
    fill: "#32d1c8",
    fillOpacity: 0.08
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 168,
    r: 3,
    fill: "#60a5fa",
    fillOpacity: 0.9
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 122,
    r: 3,
    fill: "#4ade80",
    fillOpacity: 0.9
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 88,
    r: 3,
    fill: "#4ade80",
    fillOpacity: 0.9
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 62,
    r: 3,
    fill: "#facc15",
    fillOpacity: 0.9
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 40,
    r: 3,
    fill: "#fb923c",
    fillOpacity: 0.9
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 26,
    r: 3,
    fill: "#f87171",
    fillOpacity: 0.9
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 356,
    y: 193,
    textAnchor: "middle",
    fontSize: 7.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF"
  }, "Storage Capacity")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 297,
    y: 98,
    textAnchor: "middle",
    fontSize: 7.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90,297,98)"
  }, "Flow Capacity")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChartZones);
export default __webpack_public_path__ + "static/media/empty-chart-zones.4fb0590d8a739a6885dd8523796fbcaa.svg";
export { ForwardRef as ReactComponent };